import axios from "@/plugins/axios";
import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchSaleCustomerDaily(context, searchItem) {
            let url = "sale_customer_dailies?page="  + searchItem.page + '&order[totalPurchase]=desc'

            if (!context.state.saleCustomerDaily.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.dateTo) {
                url = url + '&dateTime[before]=' + searchItem.dateTo
            }

            if (searchItem.dateFrom) {
                url = url + '&dateTime[after]=' + searchItem.dateFrom
            }

            if (searchItem.companyName) {
                url = url + "&customer.customerCompany.name=" + searchItem.companyName
            }

            if (searchItem.givenName) {
                url = url + "&customer.person.givenName=" + searchItem.givenName
            }

            if (searchItem.familyName) {
                url = url + "&customer.person.familyName=" + searchItem.familyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleCustomerDaily', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchSaleCustomerDailyPurchaseCount(context, data) {
            if (!context.state.saleCustomerDailyPurchaseCount.isNeedFetch) {
                return
            }

            return pushModel(context, 'sale_customer_dailies/count', data, 'updateSaleCustomerDailyPurchaseCount')
        },
        fetchSaleCustomerMonthlyStat(context, data) {
            if (!context.state.saleCustomerMonthlyStat.isNeedFetch) {
                return
            }

            return pushModel(context, 'sale_customer_dailies/stat', data, 'updateSaleCustomerMonthlyStat')
        },
    },
    mutations: {
        updateSaleCustomerDaily(state, data) {
            state.saleCustomerDaily = data
            state.saleCustomerDaily.isNeedFetch = false
        },
        updateSaleCustomerDailyPurchaseCount(state, data) {
            state.saleCustomerDailyPurchaseCount.purchaseCount = data
            state.saleCustomerDailyPurchaseCount.isNeedFetch = false
        },
        updateSaleCustomerMonthlyStat(state, data) {
            state.saleCustomerMonthlyStat.daily = data
            state.saleCustomerMonthlyStat.isNeedFetch = false
        }
    },
    state: {
        saleCustomerDaily: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        saleCustomerDailyPurchaseCount: {
            purchaseCount: null,
            isNeedFetch: true
        },
        saleCustomerMonthlyStat: {
            daily: [],
            isNeedFetch: true
        }
    },
    getters: {
        getSaleCustomerDaily(state) {
            return state.saleCustomerDaily.models
        },
        getSaleCustomerDailyTotalCount(state) {
            return state.saleCustomerDaily.totalItems
        },
        getSaleCustomerDailyPurchaseCount(state) {
            return state.saleCustomerDailyPurchaseCount.purchaseCount
        },
        getSaleCustomerMonthlyStat(state) {
            return state.saleCustomerMonthlyStat.daily
        }
    },
}
